/**
 * Environment configuration for Admin Panel
 */

// Auth0 client IDs — VITE_AUTH0_CLIENT_ID is always set in CI/CD pipelines.
// These constants exist only for local development so you can quickly switch
// between the production and preview Auth0 application without touching .env files.
// Production: used for the live admin panel.
// Preview:    used for PR preview deployments (less strict allowed-callback URLs).
// @ts-ignore - Used manually when switching between prod/preview for local testing
const PROD_AUTH0_CLIENT_ID = "CxvQg1niNmW25DREZgXWv91lvfTJkfMv";
const PREVIEW_AUTH0_CLIENT_ID = "74EMDVlAAuqRliTPUS4BtlYa2B8Gum3g";
// Switch the comment below to target production Auth0 locally:
const LOCAL_AUTH0_CLIENT_ID = PREVIEW_AUTH0_CLIENT_ID;
// const LOCAL_AUTH0_CLIENT_ID = PROD_AUTH0_CLIENT_ID;

export const ENV = {
  // API Configuration (varies by environment)
  API_URL: import.meta.env.VITE_API_URL || "http://localhost:3000/api",

  // Auth0 Configuration (same as frontend app.config.js)
  // In CI/CD VITE_AUTH0_CLIENT_ID is always injected; LOCAL_AUTH0_CLIENT_ID is the local fallback.
  AUTH0_DOMAIN: "login.rekindle-app.com",
  AUTH0_CLIENT_ID:
    import.meta.env.VITE_AUTH0_CLIENT_ID || LOCAL_AUTH0_CLIENT_ID,
  AUTH0_AUDIENCE: "https://api.rekindle-app.com",
  AUTH0_SCOPE: "openid profile email offline_access",

  // App Configuration
  IS_DEV: import.meta.env.DEV,
  IS_PROD: import.meta.env.PROD,
} as const;
